/* eslint-disable @typescript-eslint/no-explicit-any */
import { interpret, Interpreter } from 'xstate';
import { XStateMachine } from '../types';

export const xstateInterpreter = (
  machine: XStateMachine<any, any, any>,
): Interpreter<any, any, any> => {
  return interpret(machine);
};
